module.exports = __webpack_public_path__ + "static/media/step1.53f1cd1e.svg";